<div class="tn-advertisement">
  <div class="ad-image-wrapper">
    <img #adImage [src]="adImageSrc" (click)="onAdClick()" (load)="afterImageLoaded()">
    <div class="ad-image-close-wrapper" (click)="close()">
      <div class="btn-close"></div>
    </div>
  </div>
</div>